(function () {
	"use strict";

	/* ==========================================================
	   CONFIGURATION
	   ========================================================== */
	var isMobile = window.innerWidth <= 540;
	const ROWS = isMobile ? 8 : 11;
	const TOTAL_SLOTS = isMobile ? 9 : 12;
	const WIDTH = isMobile ? 340 : 500;
	const GAP = 34;
	const PEG_RAD = 4.5;
	const BALL_RAD = 7.5;
	const HEIGHT = (ROWS + 2) * GAP + 30;

	// How long to wait (ms) before the popup appears. Client wants ~3-4s,
	// not instant. Change this one number to tune the delay (e.g. 2000 or 3000).
	const REVEAL_DELAY = 4000;

	// Slot labels — 9 slots (mobile): 3x each; 12 slots (desktop/tablet): 4x each
	const SLOT_LABELS_9 = [
		"10%", "5%", "15%", "5%", "10%", "15%", "5%", "15%", "10%"
	];
	const SLOT_TYPES_9 = [
		"10", "5", "15", "5", "10", "15", "5", "15", "10"
	];
	const SLOT_LABELS_12 = [
		"10%", "5%", "15%", "10%", "5%", "15%", "10%", "15%", "5%", "10%", "15%", "5%"
	];
	const SLOT_TYPES_12 = [
		"10", "5", "15", "10", "5", "15", "10", "15", "5", "10", "15", "5"
	];
	const SLOT_LABELS = TOTAL_SLOTS === 9 ? SLOT_LABELS_9 : SLOT_LABELS_12;
	const SLOT_TYPES = TOTAL_SLOTS === 9 ? SLOT_TYPES_9 : SLOT_TYPES_12;

	// Coupon codes (5-letter, contain digit hints but jumbled)
	const COUPONS = {
		5:  "BZ05R",
		10: "KX10W",
		15: "QR15J"
	};

	/* ==========================================================
	   COOKIE HELPERS
	   ========================================================== */
	function setCookie(name, value, days) {
		const d = new Date();
		d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
	}

	function getCookie(name) {
		const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
		return match ? decodeURIComponent(match[2]) : null;
	}

	/* ==========================================================
	   CHECK IF ALREADY PLAYED (cookie: 30 days)
	   ========================================================== */
	const COOKIE_NAME = "plinko_played";
	if (getCookie(COOKIE_NAME)) {
		var popup = document.getElementById("plinko-popup");
		if (popup) popup.classList.add("hidden");
		return;
	}

	/* ==========================================================
	   MATTER.JS ALIASES
	   ========================================================== */
	var Engine = Matter.Engine,
		Render = Matter.Render,
		Bodies = Matter.Bodies,
		Composite = Matter.Composite;

	/* ==========================================================
	   BUILD SLOT UI
	   ========================================================== */
	var slotsContainer = document.getElementById("slots");
	SLOT_LABELS.forEach(function (label, i) {
		var el = document.createElement("div");
		el.className = "slot slot-" + SLOT_TYPES[i];
		el.id = "slot-" + i;
		el.textContent = label;
		slotsContainer.appendChild(el);
	});

	/* ==========================================================
	   PHYSICS ENGINE
	   ========================================================== */
	var engine = Engine.create({ gravity: { scale: 0.0006 } });

	var canvas = document.getElementById("canvas");
	var render = Render.create({
		canvas: canvas,
		engine: engine,
		options: {
			width: WIDTH,
			height: HEIGHT,
			wireframes: false,
			background: "transparent"
		}
	});

	// Pegs
	var pegs = [];
	for (var r = 0; r < ROWS; r++) {
		var pegsInRow = r + 3;
		for (var c = 0; c < pegsInRow; c++) {
			var x = WIDTH / 2 + (c - (pegsInRow - 1) / 2) * GAP;
			var y = GAP * 1.5 + r * GAP;
			var peg = Bodies.circle(x, y, PEG_RAD, {
				isStatic: true,
				label: "Peg",
				render: { fillStyle: "#ffffff" }
			});
			pegs.push(peg);
		}
	}
	// Walls (invisible, keep ball inside the board)
	var wallThickness = 20;
	var boardLeft = WIDTH / 2 - (TOTAL_SLOTS / 2) * GAP;
	var boardRight = WIDTH / 2 + (TOTAL_SLOTS / 2) * GAP;

	Composite.add(engine.world, pegs);

	// Peg glow tracking
	var pegAnims = new Array(pegs.length).fill(null);
	var wallInset = 6; // move walls inward to prevent ball wedging on edge pegs
	var leftWall = Bodies.rectangle(
		boardLeft + wallInset - wallThickness / 2, HEIGHT / 2,
		wallThickness, HEIGHT * 2,
		{ isStatic: true, label: "Wall", render: { visible: false } }
	);
	var rightWall = Bodies.rectangle(
		boardRight - wallInset + wallThickness / 2, HEIGHT / 2,
		wallThickness, HEIGHT * 2,
		{ isStatic: true, label: "Wall", render: { visible: false } }
	);

	// Divider bars at the bottom to channel ball into slots
	var dividers = [];
	// IMPORTANT: last peg row is at r = ROWS-1, so Y = GAP*1.5 + (ROWS-1)*GAP
	var lastPegY = GAP * 1.5 + (ROWS - 1) * GAP;
	var dividerH = 28;
	var pegBottom = lastPegY + PEG_RAD;
	var cssMargin = 2;
	// Equal-gap formula: gap above dividers = gap below dividers (to slot boxes)
	var dividerTopY = (HEIGHT - dividerH + cssMargin + pegBottom) / 2;
	var dividerCenterY = dividerTopY + dividerH / 2;
	for (var d = 0; d <= TOTAL_SLOTS; d++) {
		var dx = WIDTH / 2 + (d - TOTAL_SLOTS / 2) * GAP;
		var div = Bodies.rectangle(dx, dividerCenterY, 3, dividerH, {
			isStatic: true,
			label: "Divider",
			render: { fillStyle: "rgba(255,255,255,0.2)" }
		});
		dividers.push(div);
	}

	// Ground
	var ground = Bodies.rectangle(WIDTH / 2, HEIGHT + 20, WIDTH * 2, 40, {
		isStatic: true, label: "Ground", render: { visible: false }
	});

	Composite.add(engine.world, [leftWall, rightWall, ground].concat(dividers));

	/* ==========================================================
	   DROP POSITION
	   ========================================================== */
	// Ball drops randomly within the first 3 pegs (center ± GAP).
	// Pure physics determines the outcome — no hidden forces.
	function getDropX() {
		var center = WIDTH / 2;
		return center + (Math.random() - 0.5) * GAP * 1.4;
	}

	/* ==========================================================
	   GAME STATE
	   ========================================================== */
	var ballDropped = false;
	var gameResolved = false;

	/* ==========================================================
	   DROP BUTTON
	   ========================================================== */
	var dropButton = document.getElementById("drop-button");
	var dropButtonMobile = document.getElementById("drop-button-mobile");

	function handleDrop() {
		if (ballDropped) return;
		ballDropped = true;
		dropButton.disabled = true;
		dropButtonMobile.disabled = true;

		var x = getDropX();
		var y = -BALL_RAD;

		var ball = Bodies.circle(x, y, BALL_RAD, {
			label: "Ball",
			restitution: 0.5,
			friction: 0.1,
			render: { fillStyle: "#FC9209" }
		});
		Composite.add(engine.world, [ball]);
	}

	dropButton.addEventListener("click", handleDrop);
	dropButtonMobile.addEventListener("click", handleDrop);

	/* ==========================================================
	   COLLISION DETECTION
	   ========================================================== */
	function checkCollision(event, label1, label2, callback) {
		event.pairs.forEach(function (pair) {
			var bodyA = pair.bodyA, bodyB = pair.bodyB;
			var body1, body2;
			if (bodyA.label === label1 && bodyB.label === label2) {
				body1 = bodyA; body2 = bodyB;
			} else if (bodyA.label === label2 && bodyB.label === label1) {
				body1 = bodyB; body2 = bodyA;
			}
			if (body1 && body2) callback(body1, body2);
		});
	}

	Matter.Events.on(engine, "collisionStart", function (event) {
		// Ball hits ground — resolve game
		checkCollision(event, "Ball", "Ground", function (ball) {
			if (gameResolved) return;
			gameResolved = true;
			Matter.Composite.remove(engine.world, ball);

			var idx = Math.round(
				(ball.position.x - WIDTH / 2) / GAP + (TOTAL_SLOTS - 1) / 2
			);
			idx = Math.max(0, Math.min(TOTAL_SLOTS - 1, idx));

			var slotEl = document.getElementById("slot-" + idx);
			if (slotEl) slotEl.dataset.hit = "true";

			var discount = parseInt(SLOT_TYPES[idx]) || 0;
			setTimeout(function () {
				showResult(discount);
			}, 600);
		});

		// Ball hits peg — glow
		checkCollision(event, "Peg", "Ball", function (peg) {
			var idx = pegs.indexOf(peg);
			if (idx !== -1 && !pegAnims[idx]) {
				pegAnims[idx] = Date.now();
			}
		});
	});

	/* ==========================================================
	   RESULT POPUP
	   ========================================================== */
	function showResult(discount) {
		var overlay = document.getElementById("result-overlay");
		var title = document.getElementById("result-title");
		var message = document.getElementById("result-message");
		var couponBox = document.getElementById("coupon-box");
		var couponCode = document.getElementById("coupon-code");

		title.textContent = discount + "% Off!";
		title.className = "result-title win";
		message.textContent = "Congratulations! Use the code below at checkout.";
		couponCode.textContent = COUPONS[discount];
		couponBox.classList.remove("hidden");
		spawnConfetti();

		overlay.classList.remove("hidden");

		// Store cookie — played for 30 days
		setCookie(COOKIE_NAME, "1", 30);
	}

	// Copy button
	document.getElementById("copy-btn").addEventListener("click", function () {
		var code = document.getElementById("coupon-code").textContent;
		if (navigator.clipboard) {
			navigator.clipboard.writeText(code);
		} else {
			var ta = document.createElement("textarea");
			ta.value = code;
			document.body.appendChild(ta);
			ta.select();
			document.execCommand("copy");
			document.body.removeChild(ta);
		}
		this.textContent = "Copied!";
		var btn = this;
		setTimeout(function () { btn.textContent = "Copy"; }, 1500);
	});

	// Close result
	document.getElementById("result-close").addEventListener("click", function () {
		document.getElementById("result-overlay").classList.add("hidden");
		document.getElementById("plinko-popup").classList.add("hidden");
	});

	// Close result overlay (X)
	document.getElementById("result-overlay-close").addEventListener("click", function () {
		document.getElementById("result-overlay").classList.add("hidden");
		document.getElementById("plinko-popup").classList.add("hidden");
	});

	// Close popup (X)
	document.getElementById("close-popup").addEventListener("click", function () {
		document.getElementById("plinko-popup").classList.add("hidden");
	});

	/* ==========================================================
	   CONFETTI
	   ========================================================== */
	function spawnConfetti() {
		var container = document.getElementById("confetti-container");
		container.innerHTML = "";
		var colors = ["#0EBAEE", "#FC9209", "#FFD666", "#f04e37", "#ffffff"];
		for (var i = 0; i < 40; i++) {
			var piece = document.createElement("div");
			piece.className = "confetti-piece";
			piece.style.left = Math.random() * 100 + "%";
			piece.style.background = colors[Math.floor(Math.random() * colors.length)];
			piece.style.animationDelay = (Math.random() * 0.6) + "s";
			piece.style.animationDuration = (1.2 + Math.random() * 0.8) + "s";
			container.appendChild(piece);
		}
	}

	/* ==========================================================
	   RENDER LOOP
	   ========================================================== */
	Render.run(render);

	/* ==========================================================
	   DYNAMIC SLOT ALIGNMENT
	   Measures actual canvas display width and sets slot sizes
	   so they perfectly match divider positions at any scale.
	   ========================================================== */
	function alignSlots() {
		var canvasEl = document.getElementById("canvas");
		var displayW = canvasEl.getBoundingClientRect().width;
		var scale = displayW / WIDTH;
		var boardDisplayW = TOTAL_SLOTS * GAP * scale;
		var slotGap = Math.max(2, Math.round(3 * scale));
		var slotW = (boardDisplayW - (TOTAL_SLOTS - 1) * slotGap) / TOTAL_SLOTS;
		var sc = document.getElementById("slots");
		sc.style.width = Math.round(boardDisplayW) + "px";
		sc.style.gap = slotGap + "px";
		sc.style.margin = cssMargin + "px auto 0";
		var slotEls = sc.querySelectorAll(".slot");
		slotEls.forEach(function(el) {
			el.style.width = Math.floor(slotW) + "px";
		});
	}
	setTimeout(alignSlots, 50);
	window.addEventListener("resize", alignSlots);

	var ctx = canvas.getContext("2d");
	function run() {
		var now = Date.now();

		// Peg glow animations
		pegAnims.forEach(function (anim, index) {
			if (!anim) return;
			var delta = now - anim;
			if (delta > 800) { pegAnims[index] = null; return; }
			var peg = pegs[index];
			var pct = delta / 800;
			var expand = 1 - Math.abs(pct * 2 - 1);
			var rad = expand * 10;
			ctx.fillStyle = "rgba(14,186,238,0.15)";
			ctx.beginPath();
			ctx.arc(peg.position.x, peg.position.y, rad, 0, 2 * Math.PI);
			ctx.fill();
		});

		Engine.update(engine, 1000 / 60);
		requestAnimationFrame(run);
	}

	run();

	/* ==========================================================
	   DELAYED REVEAL
	   Show the popup REVEAL_DELAY ms after load instead of instantly.
	   (Played/closed users return early above, so this only fires for
	   first-time visitors who should actually see the popup.)
	   ========================================================== */
	var plinkoPopupEl = document.getElementById("plinko-popup");
	setTimeout(function () {
		if (!plinkoPopupEl) return;
		alignSlots(); // re-measure slot widths right before it becomes visible
		plinkoPopupEl.classList.add("plinko-ready");
	}, REVEAL_DELAY);
})();
